'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
var CategoryTitle = require('../../01.atoms/CategoryTitle/CategoryTitle.js');
var Headline = require('../../01.atoms/Headline/Headline.js');
var globals = require('../../../utils/globals.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-teaser-box',
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnCategory = "".concat(CLASSNAME, "__category"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnContentWrapper = "".concat(CLASSNAME, "__content-wrapper"),
    cnContent = "".concat(CLASSNAME, "__content"),
    cnBackground = "".concat(CLASSNAME, "__background"),
    cnLock = "".concat(CLASSNAME, "__lock");
/**
 * 
 */

var TeaserBox = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(TeaserBox, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(TeaserBox);

  function TeaserBox() {
    _rollupPluginBabelHelpers.classCallCheck(this, TeaserBox);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(TeaserBox, [{
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
          headline = _this$props.headline,
          iconId = _this$props.iconId,
          content = _this$props.content,
          background = _this$props.background,
          breakpoint = _this$props.breakpoint,
          headlineLevel = _this$props.headlineLevel,
          link = _this$props.link,
          onClick = _this$props.onClick,
          locked = _this$props.locked,
          lockedText = _this$props.lockedText,
          categoryTitle = _this$props.categoryTitle,
          onShowLogin = _this$props.onShowLogin,
          keys = Object.keys(globals.breakpoints),
          index = Math.min(keys.indexOf(breakpoint), keys.length - 2) || 0,
          size = background && background.indexOf('?w') < 0 ? "?w=".concat(Math.min(globals.breakpoints[keys[index + 1]].match(/\d+/) - 0, 1440)) : '';
      var backgroundImage = background ? "url(".concat(background).concat(size, ")") : null;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, locked && /*#__PURE__*/React__default.createElement("div", {
        className: cnLock,
        onClick: onShowLogin
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "lock-closed",
        size: "sm"
      }), /*#__PURE__*/React__default.createElement("span", null, lockedText)), /*#__PURE__*/React__default.createElement("div", {
        className: cnBackground,
        style: {
          backgroundImage: backgroundImage
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: cnContentWrapper
      }, categoryTitle && /*#__PURE__*/React__default.createElement(CategoryTitle, {
        className: cnCategory
      }, categoryTitle), /*#__PURE__*/React__default.createElement(Headline, {
        className: cnTitle,
        level: headlineLevel
      }, headline), content && /*#__PURE__*/React__default.createElement("p", {
        className: cnContent
      }, content), (link || onClick) && /*#__PURE__*/React__default.createElement(Icon, {
        className: cnIcon,
        id: iconId,
        size: "sm"
      })), (link || onClick) && /*#__PURE__*/React__default.createElement(MaterialDrop, null));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          style = _this$props2.style,
          link = _this$props2.link,
          locked = _this$props2.locked,
          onClick = _this$props2.onClick,
          classes = [className, CLASSNAME, "".concat(CLASSNAME, "--").concat(style)];

      if (!link || locked) {
        var Tag = onClick ? 'a' : 'div';
        var props = onClick ? {
          href: '#'
        } : {};
        return /*#__PURE__*/React__default.createElement(Tag, _rollupPluginBabelHelpers.extends({
          className: classNames(classes),
          onClick: onClick
        }, props), this.renderContent());
      }

      return /*#__PURE__*/React__default.createElement(Link, {
        link: link,
        className: classNames(classes)
      }, this.renderContent());
    }
  }]);

  return TeaserBox;
}(React__default.Component);
TeaserBox.propTypes = {
  /** Background image */
  background: PropTypes.string,

  /** Style breakpoint */
  breakpoint: PropTypes.string,

  /** Category title */
  categoryTitle: PropTypes.string,

  /** Additional class name */
  className: PropTypes.string,

  /** Content text */
  content: PropTypes.string,

  /** Level of headline e.g. 1 for h1 */
  headlineLevel: PropTypes.number,

  /** Title string */
  headline: PropTypes.string,

  /** Id of icon */
  iconId: PropTypes.string,

  /** URL to link to */
  link: PropTypes.string,

  /** True if not available */
  locked: PropTypes.bool,

  /** Callback function */
  onClick: PropTypes.func,

  /** Callback function */
  onShowLogin: PropTypes.func,

  /** Styling options */
  style: PropTypes.oneOf(['light', 'dark'])
};
TeaserBox.defaultProps = {
  breakpoint: 'md',
  headlineLevel: 3,
  iconId: 'arrow-right',
  lockedText: 'Login to read this article',
  onShowLogin: function onShowLogin() {
    return void 0;
  },
  style: 'dark'
};

module.exports = TeaserBox;
